import React, { Component } from 'react';
import homedata from '../../data/homedata.json';

class FeatureOne extends Component {
  render() {
   let publicUrl = process.env.PUBLIC_URL
   const data = this.props.data || homedata.feature1;

    return (
      <section id="feature1" className="p-80px-tb featured-1 position-relative">
         <div className="bordered-circle2"></div>
         <div className="container">
            <div className="row align-items-center">
               <div className="col-lg-6 md-m-50px-b">
                  {/* Solution visual */}
                  <img
                    className="img-fluid rounded"
                    src={publicUrl + '/assets/img/service-section-bg.webp'}
                    alt="AIアシスタント"/>
               </div>
               <div className="col-lg-6">
                  <div className="section-title m-30px-b">
                     <h2>{data.sectiontitle || data.title}</h2>
                     {data.subtitle && <h3 className="h4 text-primary m-30px-b">{data.subtitle}</h3>}
                  </div>
                  <p className="lead m-25px-b">{data.content}</p>
                  {data.highlight && (
                    <div className="alert alert-primary p-30px m-30px-b">
                      <h4 className="alert-heading font-weight-bold">{data.highlight}</h4>
                    </div>
                  )}
                  {data.description && (
                    <p className="text-muted">{data.description}</p>
                  )}
                  {data.btn1url && (
                    <a href={data.btn1url} className="btn btn-default btn-filled animated-btn">{data.btn1label}</a>
                  )}
               </div>
            </div>
         </div>
      </section>

    );
  }
}

export default FeatureOne;
